import keyMirror from 'keymirror';

export const COLORS = keyMirror({
	BLUE: null,
	BLACK: null,
});
